import styled from "styled-components";
import { useTranslation } from "react-i18next"
import { Widget } from "datastake-daf/dist/components";

const Style = styled.div`
  display: flex;

  .widget-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0px var(--size-lg);
    border-right: 1px solid var(--base-gray-40);

    &:first-of-type {
      padding-left: 0px;
    }

    &:last-of-type {
      padding-right: 0px;
      border-right: 0px;
    }

    label {
      font-size: 14px;
      color: var(--base-gray-70);
      font-weight: 500;
      margin-bottom: 13px;
    }

    span {
      font-size: 14px;
      color: var(--base-gray-90);
      font-weight: 500;
      margin-bottom: 0px;
    }
  }
`;

export default function SourceDetails({ loading, data = {} }) {
  const { t } = useTranslation();

  return (
    <Widget
      loading={loading}
      title={t('Source')}
      className="with-border-header flex-1 h-w-btn-header"
    >
      <Style>
        <div className="widget-column">
          <label>{t('Source Name')}</label>
          <span>{data?.source?.name}</span>
        </div>

        <div className="widget-column">
          <label>{t('Origin')}</label>
          <span>{data?.origin || '--'}</span>
        </div>

        <div className="widget-column">
          <label>{t('Total Data Points')}</label>
          <span>{data?.datapoints?.length || 0}</span>
        </div>
      </Style>
    </Widget>
  );
}
